import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const layoutGridSlice = createAppSlice({
  name: 'layout-grid',
  initialState,
  reducers,
});

export const {
  changeLayoutDirection,
  togglePanel,
  toggleOppositePanel,
  toggleFooter,
  togglePillar,
  toggleHeader,
  setViewSize,
  changeGridLayouts,
  resetPreFullscreenState,
  setLayoutGridState,
  setTrackedBodyAttributes,
} = layoutGridSlice.actions;

export default layoutGridSlice.reducer;
